<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2022-04-27 17:51:11
 * @LastEditors: zailong
 * @LastEditTime: 2024-03-20 10:07:18
-->
<template>
  <div class="app-container">
    <div class="admission-box">
      <div class="admission-title">机构入驻申请</div>
      <div class="admission-contend">
        <div class="admission-item">
          <div class="admission-box">
            <div class="checked-info" v-show="ordinaryStep === 3">
              普通机构已认证
            </div>
            <div class="admission-box-top">
              <img
                src="@assets/admission/ordinary.png"
                class="admission-icon"
              />
              <p class="admission-type">普通机构</p>
              <p class="admission-msg">
                请提前准备好申请材料，如营业执照、入驻承诺书等
              </p>
            </div>
            <div class="admission-box-steps">
              <div class="result-box">
                <div
                  class="check-result"
                  :class="{
                    success: ordinaryStep === 3,
                    reject: ordinaryStep === 2 || ordinaryStep === 4,
                    review: ordinaryStep === 1
                  }"
                >
                  <div>
                    <img
                      v-if="ordinaryStep === 1"
                      class="time-filled"
                      src="@/assets/admission/time-filled.png"
                      alt=""
                    />
                    <i
                      v-else
                      :class="
                        ordinaryStep === 3
                          ? 'el-icon-success'
                          : ordinaryStep === 2 || ordinaryStep === 4
                          ? 'el-icon-info'
                          : ''
                      "
                    ></i>
                    {{
                      ordinaryStep === 3
                        ? '审核成功'
                        : ordinaryStep === 2
                        ? '审核驳回'
                        : ordinaryStep === 1
                        ? '审核中'
                        : ordinaryStep === 4
                        ? '审核退回'
                        : ''
                    }}
                  </div>
                  <div
                    class="view-btn"
                    v-if="ordinaryStep === 2 || ordinaryStep === 4"
                    @click="dialogVisible = true"
                  >
                    查看原因
                  </div>
                </div>
                <!--              <div
                  class="reject-reason"
                  v-show="ordinaryStep === 2 || ordinaryStep === 4"
                >
                  <span class="reason-label">{{
                    ordinaryStep === 2 ? '驳回原因 :' : '退回原因 :'
                  }}</span>
                  <span class="reason-msg">{{ remarks }}</span>
                </div> -->
              </div>
              <div class="step-box">
                <p class="step-title">申请步骤</p>
                <div class="step-content">
                  <div class="step-item">
                    <div
                      class="step-icon"
                      v-show="ordinaryStep == 1 || ordinaryStep == 3"
                    >
                      <i class="el-icon-check"></i>
                    </div>
                    <div
                      class="step-icon unactive"
                      v-show="
                        ordinaryStep == 0 ||
                        ordinaryStep == 2 ||
                        ordinaryStep == 4
                      "
                    >
                      1
                    </div>
                    <span>填写申请材料</span>
                  </div>
                  <div class="step-line">
                    <div class="line"></div>
                  </div>
                  <div class="step-item">
                    <div class="step-icon" v-show="ordinaryStep === 3">
                      <i class="el-icon-check"></i>
                    </div>
                    <div class="step-icon unactive" v-show="ordinaryStep !== 3">
                      2
                    </div>
                    <span>等待管理员审核</span>
                  </div>
                  <div class="step-line">
                    <div class="line"></div>
                  </div>
                  <div class="step-item">
                    <div class="step-icon" v-show="ordinaryStep === 3">
                      <i class="el-icon-check"></i>
                    </div>
                    <div class="step-icon unactive" v-show="ordinaryStep !== 3">
                      3
                    </div>
                    <span>认证成功</span>
                  </div>
                </div>
              </div>
              <div class="apply-btn" @click="apply(1, ordinaryStep)">
                {{
                  ordinaryStep === 0
                    ? '立即申请'
                    : ordinaryStep === 3
                    ? '查看详情'
                    : '修改信息'
                }}
              </div>
            </div>
          </div>
        </div>
        <div class="admission-item">
          <div class="admission-box">
            <div class="checked-info" v-show="serverStep === 3">
              服务券机构已认证
            </div>
            <div class="admission-box-top">
              <img src="@assets/admission/server.png" class="admission-icon" />
              <p class="admission-type">服务券机构</p>
              <p class="admission-msg">
                请提前准备好申请材料，如营业执照、法人身份证、服务资质证明、上年度企业服务成效证明、从业人员职称或从业资格证、入驻承诺书等
              </p>
            </div>
            <div class="admission-box-steps">
              <div class="result-box">
                <div
                  class="check-result"
                  :class="{
                    success: serverStep === 3,
                    reject: serverStep === 2 || serverStep === 4,
                    review: serverStep === 1
                  }"
                >
                  <div>
                    <img
                      v-if="serverStep === 1"
                      class="time-filled"
                      src="@/assets/admission/time-filled.png"
                      alt=""
                    />
                    <i
                      v-else
                      :class="
                        serverStep === 3
                          ? 'el-icon-success'
                          : serverStep === 2 || serverStep === 4
                          ? 'el-icon-info'
                          : ''
                      "
                    ></i>
                    {{
                      serverStep === 3
                        ? '审核成功'
                        : serverStep === 2
                        ? '审核驳回'
                        : serverStep === 1
                        ? '审核中'
                        : serverStep === 4
                        ? '审核退回'
                        : ''
                    }}
                  </div>
                  <div
                    class="view-btn"
                    v-if="serverStep === 2 || serverStep === 4"
                    @click="dialogVisible = true"
                  >
                    查看原因
                  </div>
                </div>
                <!-- <div
                  class="reject-reason"
                  v-show="serverStep === 2 || serverStep === 4"
                >
                  <span class="reason-label">{{
                    serverStep === 2 ? '驳回原因 :' : '退回原因 :'
                  }}</span>
                  <span class="reason-msg">{{ remarks }}</span>
                </div> -->
              </div>
              <div class="step-box">
                <p class="step-title">申请步骤</p>
                <div class="step-content">
                  <div class="step-item">
                    <div
                      class="step-icon"
                      v-show="serverStep == 1 || serverStep == 3"
                    >
                      <i class="el-icon-check"></i>
                    </div>
                    <div
                      class="step-icon unactive"
                      v-show="
                        serverStep == 0 || serverStep == 2 || serverStep == 4
                      "
                    >
                      1
                    </div>
                    <span>填写申请材料</span>
                  </div>
                  <div class="step-line">
                    <div class="line"></div>
                  </div>
                  <div class="step-item">
                    <div class="step-icon" v-show="serverStep === 3">
                      <i class="el-icon-check"></i>
                    </div>
                    <div class="step-icon unactive" v-show="serverStep !== 3">
                      2
                    </div>
                    <span>等待管理员审核</span>
                  </div>
                  <div class="step-line">
                    <div class="line"></div>
                  </div>
                  <div class="step-item">
                    <div class="step-icon" v-show="serverStep === 3">
                      <i class="el-icon-check"></i>
                    </div>
                    <div class="step-icon unactive" v-show="serverStep !== 3">
                      3
                    </div>
                    <span>认证成功</span>
                  </div>
                </div>
              </div>
              <div
                class="apply-btn"
                :class="{ unclick: ordinaryStep !== 3 }"
                @click="apply(2, serverStep)"
              >
                {{
                  serverStep === 0
                    ? '立即申请'
                    : serverStep === 3
                    ? '查看详情'
                    : '修改信息'
                }}
              </div>
            </div>
          </div>
          <div class="admission-tips">
            注意：请先申请成为普通机构，再申请服务券机构
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="查看原因" :visible.sync="dialogVisible" width="30%">
      <span class="remarks-title"
        >{{
          ordinaryStep === 2 || serverStep === 2 ? '驳回' : '退回'
        }}理由</span
      >
      <div class="remarks-box">{{ remarks }}</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  checkStatus,
  checkTimeSetting
} from '@api/yardIntermediary/applicationResidency'
export default {
  name: 'Admission',
  data() {
    return {
      creditCode: '',
      organizationType: 1, // 机构类型
      remarks: null, // 备注
      status: 0, // 审核状态
      ordinaryStep: 0, // 普通机构校验状态
      serverStep: 0, // 服务券机构校验状态
      dialogVisible: false
    }
  },
  watch: {},
  computed: {},
  created() {
    this.getStatus(1)
  },
  mounted() { },
  methods: {
    // 获取企业认证状态
    getStatus(type) {
      let params = {
        organizationType: type
      }
      checkStatus(params).then((res) => {
        if (res.data.code == '0000') {
          const data = res.data.data[0] || {}
          this.organizationType = data.organizationType
          this.remarks = data.remarks || ''
          this.creditCode = data.creditCode || ''
          this.status = data.status || 0 // 0未审核 1待评审 2 已驳回 3 评审通过 4 退回
          if (this.organizationType == 1) {
            this.serverStep = 0
            this.ordinaryStep = this.status
          }
          if (this.organizationType == 2) {
            this.ordinaryStep = 3
            this.serverStep = this.status
          }
          // 普通机构认证通过后，开启服务券机构认证
          if (this.status == 3 && this.organizationType == 1) {
            this.getStatus(2)
          }
        }
      })
    },
    // 立即申请 1普通券机构 2 服务券机构 ordinaryStep serverStep
    apply(type, step) {
      if (type === 2 && this.ordinaryStep !== 3) return
      let actionType = step === 0 ? 'add' : step === 3 ? 'view' : 'edit'
      let params = {
        creditCode: this.creditCode,
        organizationType: type
      }
      // 审核通过，查看详情跳过权限
      if (
        (this.ordinaryStep == 3 && type == 1) ||
        (this.serverStep == 3 && type == 2)
      ) {
        this.$router.push({
          name: 'serviceVoucher',
          query: {
            type: type,
            actionType: actionType,
            creditCode: this.creditCode
          }
        })
        return
      }
      checkTimeSetting(params).then((res) => {
        if (res.data.code == '0000') {
          this.$router.push({
            name: 'serviceVoucher',
            query: {
              type: type,
              actionType: actionType,
              creditCode: this.creditCode
            }
          })
        } else {
          this.$message.error(res.data.msg)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-dialog {
  .el-dialog__header {
    padding: 16px 24px;
  }
  .el-dialog__title {
    font-weight: 700;
    font-size: 16px;
  }
  .el-dialog__body {
    border-top: 1px solid rgba(0, 0, 0, 0.09);
    border-bottom: 1px solid rgba(0, 0, 0, 0.09);
    padding: 24px 24px 40px !important;
  }
  .remarks-title {
    font-weight: 700;
    font-size: 14px;
    color: #000000;
  }
  .remarks-box {
    border: 1px solid rgba(0, 0, 0, 0.15);
    height: 136px;
    border-radius: 4px;
    margin-top: 10px;
    padding: 10px 15px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 500;
    font-size: 14px;
    overflow-y: auto;
    line-height: 24px;
  }
}

.admission-box {
  height: 100%;
  .admission-title {
    line-height: 25px;
    text-align: center;
    height: 25px;
    color: rgba(0, 0, 0, 0.85);
    font-size: 18px;
    font-weight: 600;
    font-family: PingFangSC-Bold;
    margin-top: 16px;
    margin-bottom: 30px;
  }
  .admission-contend {
    width: 50%;
    min-width: 792px;
    height: calc(100% - 71px);
    display: flex;
    margin: auto;
    justify-content: space-between;
    .admission-item {
      width: 48%;
      min-width: 381px;
      .admission-box {
        height: 70%;
        min-height: 502px;
        padding: 20px;
        box-sizing: border-box;
        border-radius: 4px;
        background-color: rgba(248, 249, 253, 1);
        border: 1px solid rgba(234, 239, 245, 1);
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        position: relative;
        .checked-info {
          position: absolute;
          left: 0;
          top: 0;
          line-height: 36px;
          border-radius: 4px;
          padding: 0 16px 0 30px;
          background-color: rgba(255, 235, 229, 1);
          border: 1px solid rgba(255, 223, 212, 1);
          color: rgba(255, 82, 24, 100);
          font-size: 12px;
          font-family: PingFangSC-Medium;
          border-bottom-right-radius: 20px;
        }
        .checked-info::before {
          content: '';
          position: absolute;
          top: 12px;
          left: 8px;
          width: 14px;
          height: 14px;
          background: url('~@assets/admission/checked.png') no-repeat;
          background-size: 100% 100%;
        }
        .admission-box-top {
          text-align: center;
          cursor: default;
          .admission-icon {
            width: 48px;
            height: 48px;
            margin-top: 20px;
          }
          .admission-type {
            line-height: 22px;
            height: 22px;
            color: rgba(0, 0, 0, 0.85);
            font-size: 16px;
            font-family: PingFangSC-Medium;
            margin: 12px 0;
          }
          .admission-msg {
            line-height: 23px;
            color: rgba(0, 0, 0, 0.65);
            font-size: 14px;
            text-align: left;
            font-family: PingFangSC-Medium;
            margin: 12px 0;
          }
        }
        .admission-box-steps {
          .result-box {
            margin-bottom: 13px;
            .check-result {
              width: 100%;
              height: 32px;
              line-height: 32px;
              font-size: 14px;
              border-radius: 3px;
              display: inline-block;
              padding: 0 8px 0 9px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              font-weight: 700;
              .view-btn {
                color: rgba(0, 0, 0, 0.85);
                cursor: pointer;
              }
              .time-filled {
                width: 14.5px;
                height: 14.5px;
                vertical-align: text-top;
              }
            }
            .success {
              background-color: rgba(82, 196, 26, 0.1);
              color: #52c41a;
              border: 1px solid rgba(82, 196, 26, 0.35);
            }
            .reject {
              background-color: rgba(255, 0, 0, 0.1);
              color: rgba(255, 0, 0, 100);
              border: 1px solid rgba(255, 0, 0, 0.35);
            }
            .review {
              background-color: rgba(0, 112, 255, 0.1);
              color: rgba(0, 112, 255, 1);
              border: 1px solid rgba(0, 112, 255, 0.35);
            }
            .reject-reason {
              margin-top: 4px;
              height: 23px;
              line-height: 23px;
              color: rgba(0, 0, 0, 0.65);
              font-size: 12px;
              text-align: justify;
              font-family: PingFangSC-Medium;
              display: flex;
              .reason-label {
                width: 55px;
              }
              .reason-msg {
                flex: 1;
                word-break: break-all;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1; /* 这里是超出几行省略 */
                overflow: hidden;
              }
            }
          }
          .step-box {
            border-top: 1px dashed rgba(0, 0, 0, 0.1);
            .step-title {
              width: 56px;
              height: 23px;
              line-height: 23px;
              margin: 8px 0;
              color: rgba(0, 0, 0, 0.85);
              font-size: 14px;
              text-align: center;
              font-family: PingFangSC-Medium;
            }
            .step-content {
              display: flex;
              height: 24px;
              line-height: 24px;
              color: rgba(0, 0, 0, 0.65);
              font-size: 12px;
              text-align: left;
              font-family: PingFangSC-Medium;
              justify-content: space-between;
              .step-item {
                display: flex;
                .step-icon {
                  width: 18px;
                  height: 18px;
                  border-radius: 50%;
                  line-height: 17px;
                  text-align: center;
                  margin-top: 3px;
                  border: 1px solid #1890ff;
                  margin-right: 8px;
                  background-color: white;
                  color: #1890ff;
                }
                .unactive {
                  background-color: #1890ff;
                  color: white;
                }
              }
              .step-line {
                position: relative;
                flex: 1;
                .line {
                  background-color: rgba(0, 0, 0, 0.1);
                  height: 1px;
                  position: absolute;
                  left: 10px;
                  right: 10px;
                  top: 11px;
                }
              }
            }
          }
          .apply-btn {
            width: 88px;
            height: 32px;
            line-height: 32px;
            text-align: center;
            margin: 24px auto;
            border-radius: 2px;
            color: rgba(255, 255, 255, 90);
            font-size: 14px;
            text-align: center;
            font-family: PingFangSC-Regular;
            background-color: rgba(0, 112, 255, 1);
            cursor: pointer;
          }
          .unclick {
            background-color: rgba(172, 174, 177, 1);
            color: rgba(255, 255, 255, 100);
            cursor: default;
          }
        }
      }
      .admission-tips {
        margin: 10px 0;
        height: 20px;
        line-height: 20px;
        color: rgba(0, 112, 255, 100);
        font-size: 12px;
        text-align: center;
        font-family: PingFangSC-Medium;
        cursor: default;
      }
    }
  }
}
</style>
